export enum OutclinicDashboardStatus {
    checked = 'checked',
    empty = 'empty',
    notApplicable = 'notApplicable',
    toDo = 'toDo',
    warning = 'warning',
}
